import { getDocumentIdByType, type U3141DocumentTypeEntry, type U3141LotDetail } from '../U3141Service';

/**
 * Résout l’id du document historique cadastral sur le lot maître (documentTypes).
 */
export function u3141GetHistoriqueCadastralDocumentId(
  master: { documentTypes?: U3141DocumentTypeEntry[] } | null | undefined
): string | null {
  if (!master?.documentTypes?.length) return null;
  return getDocumentIdByType(
    { documentTypes: master.documentTypes } as U3141LotDetail,
    'rfLotHistoriqueCadastral'
  );
}
